<template>
  <div style="background-color: #f0f4f7">
    <topSlider/>
    <!--  news-->
    <div v-if="news.topics!=undefined">
      <div id="news-section"></div>
      <about-title title="اخبار" page-route="/sub/light-blocks/news/all-news"/>
      <v-container>
        <v-row>
          <v-col v-for="(newsItem,i) in news.topics" :key="i" cols="12">
            <BlockNewsItem :news-item="newsItem"/>
          </v-col>
        </v-row>
        <v-pagination
          color="#74b73b"
          v-model="news_page"
          :length="news.total_pages"
        ></v-pagination>
      </v-container>
    </div>
    <!--  events-->
<!--    <div v-if="events.topics!=undefined">
      <about-title title="رویدادها" page-route="/sub/light-blocks/news/events"/>
      <v-container>
        <v-row>
          <v-col v-for="(newsItem,i) in events.topics" :key="i" cols="12">
            <BlockNewsItem :news-item="newsItem"/>
          </v-col>
        </v-row>
      </v-container>
    </div>-->
    <!--gallery-->
    <div>
      <div id="gallery-section"></div>
      <about-title page-route="/sub/light-blocks/news/gallery" :title="$t('گالری')"></about-title>
      <v-container>
        <v-row>
          <v-col v-for="(item,i) in galleryItem.topics" :key="i" cols="12" sm="12" md="6" xl="6" lg="6">
            <BlockGalleryItem :item="item"/>
          </v-col>
        </v-row>
        <v-pagination
        color="#74b73b"
          v-model="gallery_page"
          :length="galleryItem.total_pages"
        ></v-pagination>
      </v-container>
    </div>
    <!--  projects-->
    <div v-if="projects.topics!=undefined">
      <div id="projects-section"></div>
      <about-title title="پروژه ها" page-route="/sub/light-blocks/projects"/>
      <v-container>
        <v-row>
          <v-col v-for="(newsItem,i) in projects.topics" :key="i" cols="12">
            <BlockNewsItem :news-item="newsItem"/>
          </v-col>
        </v-row>
        <v-pagination
        color="#74b73b"
          v-model="projects_page"
          :length="projects.total_pages"
        ></v-pagination>
      </v-container>
    </div>
    <div v-show="$vuetify.breakpoint.smAndUp" v-if="scrolled" class="feature-box">
      <h4 class="text-decoration-underline font-weight-bold">ویژگی ها</h4>
      <h6 v-for="(item,index) in 4" :key="index"
          @click="handleChangeCat(index)"
          @mouseover="hoverTitle(index)"
          @mouseleave="scrollHover=null"
          :class="[scrollStatus===index?'green--text font-weight-bold':'','mt-4 pointer']">
        {{
          scrollStatus === index ? scrollItems[index] : scrollHover !== null && scrollHover === index ? scrollItems[scrollHover] : scrollItems[index]
        }}
      </h6>
    </div>

  </div>
</template>

<script>

import NewsItem from "./news/components/NewsItem";
import TopSlider from "./components/TopSlider";

import Gallery from "./gallery/components/gallery";
import ArticlesItems from "../Technical/articles/components/articlesItems";
import EventsItems from "./events/components/eventsItems";
import certificate from "../Technical/certificates/components/certificates";
import Projects from "./projects/BlockProjects";
import AboutTitle from "../About/Components/AboutTitle";
import {mapState} from "vuex";
import BlockNewsItem from "./components/BlockNewsItem";
import BlockGalleryItem from "./gallery/components/BlockGalleryItem";

export default {
  name: "blockNews",
  components: {
    BlockGalleryItem,
    BlockNewsItem,
    AboutTitle, Projects, certificate, EventsItems, ArticlesItems, Gallery, NewsItem, TopSlider
  },
  data() {
    return {
      projects_page:1,
      gallery_page:1,
      events_page:1,
      news_page:1,
      lastPosition: 0,
      scrollStatus: 0,
      scrollHover: null,
      limitPosition: 200,
      scrolled: false,
      scrollItems: [
        'اخبار',
        // 'رویدادها',
        'گالری',
        'پروژه ها'
      ]
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    this.$store.dispatch('lightBlocksManagement/getBlockNews',{
      page:this.news_page,
      limit:5
    });
    this.$store.dispatch('lightBlocksManagement/getBlockEvents',{
      page:this.events_page,
      limit:5
    });
    this.$store.dispatch('lightBlocksManagement/getBlockGallery',{
      page:this.gallery_page,
      limit:4
    });
    this.$store.dispatch('lightBlocksManagement/getBlockProjects',{
      page:this.projects_page,
      limit:5
    });
  },
  watch:{
    projects_page(){
      this.$store.dispatch('lightBlocksManagement/getBlockProjects',{
      page:this.projects_page,
      limit:5
    });
    },
    news_page(){
      this.$store.dispatch('lightBlocksManagement/getBlockNews',{
      page:this.news_page,
      limit:5
    });
    },
    events_page(){
      this.$store.dispatch('lightBlocksManagement/getBlockEvents',{
      page:this.events_page,
      limit:5
    });
    },
    gallery_page(){
      this.$store.dispatch('lightBlocksManagement/getBlockGallery',{
      page:this.gallery_page,
      limit:4
    });
    }
  },  
  computed: {
    ...mapState({
      news: state => state.lightBlocksManagement.blockNews,
      events: state => state.lightBlocksManagement.blockEvents,
      galleryItem: state => state.lightBlocksManagement.blockGallery,
      projects: state => state.lightBlocksManagement.blockProjects,
    })
  },
  //news 164px
  //img 240px
  methods: {
    hoverTitle(index) {
      this.scrollHover = index;
    },
    checkPosition() {
      let newsLength = Math.ceil(this.news.topics.length);
      let eventsLength = this.events.topics.length;
      let galleryLength = Math.ceil(this.galleryItem.topics.length / 2);
      let projectsLength = this.projects.topics.length;
      if (window.scrollY > (newsLength * 164) + (eventsLength * 164) + (projectsLength * 164) + galleryLength * 240 + 1500) {
        this.scrolled = false;
      } else if (this.limitPosition < window.scrollY) {
        this.scrolled = true;
      } else {
        this.scrolled = false;
      }
    },
    handleScroll() {
      this.checkPosition();
      let newsLength = Math.ceil(this.news.topics.length);
      let eventsLength = this.events.topics.length;
      let galleryLength = Math.ceil(this.galleryItem.topics.length / 2);
      let projectsLength = this.projects.topics.length;
      if (window.scrollY < 900 + (newsLength * 164)) {
        this.scrollStatus = 0;
      } else if (window.scrollY > 900 + (newsLength * 164) && window.scrollY < 900 + (newsLength * 164) + (eventsLength * 164)) {
        this.scrollStatus = 1
      } else if (window.scrollY > 900 + (newsLength * 164) + (eventsLength * 164) && window.scrollY < 900 + (newsLength * 164) + (eventsLength * 164) + (galleryLength * 240)) {
        this.scrollStatus = 2
      } else {
        this.scrollStatus = 3;
      }
    },
    handleChangeCat(index) {

      let newsLength = Math.ceil(this.news.topics.length);
      // let eventsLength = this.events.topics.length;
      let galleryLength = Math.ceil(this.galleryItem.topics.length / 2);
      let projectsLength = this.projects.topics.length;
      if (index === 0) {
        window.scrollTo(0, 400);
        this.scrollStatus = 0;
      } else if (index === 1) {
        this.scrollStatus = 1;
        window.scrollTo(0, (newsLength * 164) + 1000);

      } else if (index === 2) {
        this.scrollStatus = 2;
        window.scrollTo(0, ((newsLength +galleryLength) * 164 + 1000));
        // window.scrollTo(0, ((newsLength /*+ eventsLength*/) * 164 + 1000));
      } else if (index === 3) {
        this.scrollStatus = 3;
        window.scrollTo(0, ((newsLength + eventsLength) * 164 + galleryLength * 240 + 1000));
      }
    }
  }
}
</script>
<style scoped>

.slide-1 {
  height: 80vh;
  width: 100vw;
  background: url("../../../../../assets/images/home-slider/9.jpg") center no-repeat;
  background-size: cover;
}

.slide-2 {
  height: 80vh;
  width: 100vw;
  background: url("../../../../../assets/images/home-slider/1.jpg") center no-repeat;
  background-size: cover;
}

.slide-3 {
  height: 80vh;
  width: 100vw;
  background: url("../../../../../assets/images/home-slider/2.jpg") center no-repeat;
  background-size: cover;
}

.slide-4 {
  height: 80vh;
  width: 100vw;
  background: url("../../../../../assets/images/home-slider/12.jpg") center no-repeat;
  background-size: cover;
}

.slide-img {
  position: relative;
  transition: background 8s;
  height: 90vh;
}


.dots-box-position {
  position: absolute;
  bottom: 30px;
  right: 0;
  left: 0;
  height: 60px;
}

.slider {
  background-color: rgba(8, 70, 190, 0.44);
  height: 100%;
  z-index: 9999;
  animation-play-state: paused;
  animation: skew ease-in infinite;

}

@keyframes skew {
  from {
    width: 0
  }
  to {
    width: 100%
  }

}

.paused {
  animation-play-state: paused;
  animation-duration: 4s;
}

.resumed {
  animation-play-state: running;
  animation-duration: 4s;
}
</style>
